import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";

import moment from "moment";
import { BlurSpinner } from "../../../components/BlurSpinner";
import useFetcher from "../../../hooks/useFetcher";
import { ButtonPrimary } from "../../../ui/buttons";
import PlaybookModal from "./PlaybookModal";
import { getPlaybooks } from "../../../services/playbookServices";
import { fetchPiAsignable } from "../../../services/ticketingServices";
import { getPiById } from "../../../components/RelevosInfoGeneral/utils";

const Playbook = ({ clientId, razonSocial, filesComponent }) => {
  const [currentPerPage, setCurrentPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [params, setParams] = useState({ clientId, page: currentPage, perpage: currentPerPage });
  const [playbooks, isLoadingPlaybooks, , , refreshPlaybooks] = useFetcher(getPlaybooks, [params]);
  const [pisAsignable, isLoadingPisAsignable] = useFetcher(fetchPiAsignable, undefined, "allfetchPiAsignable");
  const playbookData = playbooks && playbooks.rows;
  const totalRows = playbooks && playbooks.count;
  const [showRegistroDeVisitasModal, setShowRegistroDeVisitasModal] = useState(false);
  // const [dataToEdit, setDataToEdit] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    filesComponent.current.refreshFiles();
  }, [playbooks]);

  useEffect(() => {
    if (params.page !== currentPage || params.perpage !== currentPerPage) {
      const newParams = { ...params, page: currentPage, perpage: currentPerPage };
      setParams(newParams);
    }
  }, [currentPage, currentPerPage]);

  // const handleRowClicked = (row) => {
  //   setDataToEdit(row);
  //   setShowRegistroDeVisitasModal(!showRegistroDeVisitasModal);
  // };

  // maneja el paginado de la tabla
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handlePerRowsChange = async (newPerPage) => {
    setLoading(true);
    setCurrentPerPage(newPerPage);

    setLoading(false);
  };

  return (
    <div style={{ fontFamily: "Nunito" }}>
      <BlurSpinner isLoading={isLoadingPlaybooks || isLoadingPisAsignable}>
        {showRegistroDeVisitasModal && (
          <PlaybookModal
            toggle={() => setShowRegistroDeVisitasModal(!showRegistroDeVisitasModal)}
            isOpen={showRegistroDeVisitasModal}
            clientId={clientId}
            razonSocial={razonSocial}
            refreshData={refreshPlaybooks}
            // dataToEdit={dataToEdit}
          />
        )}

        <div className="mt-3">
          <div className="d-flex flex-row justify-content-end align-items-center mb-3">
            <ButtonPrimary
              className="btn"
              disabled={false}
              onClick={() => {
                setShowRegistroDeVisitasModal(!showRegistroDeVisitasModal);
              }}
            >
              Nuevo Registro
            </ButtonPrimary>
          </div>

          <DataTable
            data={playbookData}
            responsive
            hover
            style={{ fontFamily: "Nunito !important" }}
            // onRowClicked={(row) => handleRowClicked(row)}
            noDataComponent={
              <div className="p-3">
                <b>No hay registros</b>
              </div>
            }
            pagination
            paginationPerPage={5}
            paginationRowsPerPageOptions={[5, 10]}
            progressPending={loading}
            paginationServer
            paginationTotalRows={totalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            paginationComponentOptions={{ rowsPerPageText: "Candidatos por página", rangeSeparatorText: "de" }}
            striped
            columns={[
              {
                name: "Creación",
                selector: (row) => (row.createdAt ? `${moment(row.createdAt).format("DD/MM/YYYY HH:mm")} hs` : "-"),
                id: "createdAt",
                center: true,
                // width: "150px",
                style: {
                  cursor: "pointer",
                  textAlign: "center",
                },
              },
              {
                name: "Responsable",
                selector: (row) => (row.createdBy && pisAsignable && pisAsignable.length > 0 ? getPiById(row.createdBy, pisAsignable) : "-"),
                center: true,
                wrap: true,

                id: "usuario",
                style: {
                  cursor: "pointer",
                  textAlign: "center",
                },
              },
            ]}
          />
        </div>
      </BlurSpinner>
    </div>
  );
};
export default Playbook;
